import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import OwLabel from "../../shared/OwLabel/OwLabel";

type Props = {};

export const ReportsNav: React.FC<Props> = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const isScheduled = location.pathname.startsWith("/reports/scheduled");

    return (
        <div className={"ReportsNav d-flex align-items-center mt-3 mb-3"}>
            <div className={"btn-group"}>
                <button className={"btn btn-primary " + (!isScheduled ? "active" : "")} onClick={() => navigate("/reports")}>
                    <OwLabel noBottomMargin={true} title={"reports"} className={"pointer"} />
                </button>
                <button className={"btn btn-primary " + (isScheduled ? "active" : "")} onClick={() => navigate("/reports/scheduled")}>
                    <OwLabel noBottomMargin={true} title={"scheduled"} className={"pointer"} />
                </button>
            </div>
        </div>
    );
};
